export var name = 'login';
export var supports = function (env) {
    return (env.isInToutiao ||
        env.isInToutiaoLite ||
        env.isInVideo ||
        env.isInAweme ||
        env.isInMobile);
};
